import {AxiosResponse} from "axios";
import {PaginationResponse, Response} from "../../types/api";
import protectedInstance from "../instances/protected";
import {Lot, LotCompanyFile, LotList, LotItem, LotsFilterParams, LotWithItemList} from "../../types/lot";
import {AuctionType} from "../../utils/enums";

async function deleteLotItem(companyId: number, lotPlantItemId: number, lotId: number) {
    return protectedInstance.delete(`/company/${companyId}/lot/${lotId}/planItem/${lotPlantItemId}`)
        .then((res: AxiosResponse<Response<any>>) => res.data)
}

async function getLot(companyId: number, lotId: number) {
    return protectedInstance.get(`/company/${companyId}/lot/${lotId}`)
        .then((res: AxiosResponse<Response<Lot>>) => res.data)
}

async function editLot(companyId: number, lotId: number, data: {
    companyId: number;
    year: number;
    auctionType: AuctionType;
    intercomId: number;
    deliveryDate: Date;
    attachments: number[];
    lotItems: number[]
}) {
    return protectedInstance.put(`/company/${companyId}/lot/${lotId}`, data)
        .then((res: AxiosResponse<Response<Lot>>) => res.data)
}

async function createLot(companyId: number, data: {
    companyId: number;
    year: number;
    auctionType: AuctionType;
    intercomId: number;
    deliveryDate: Date;
    attachments: number[];
    lotItems: number[]
}) {
    return protectedInstance.post(`/company/${companyId}/lot`, data)
        .then((res: AxiosResponse<Response<Lot>>) => res.data)
}

async function getLots(companyId: number, page: number, pageSize: number, data: LotsFilterParams | null) {
    const query = `page=${page}&page_size=${pageSize}&bin=${data?.bin || ''}&state=${data?.state || ''}&year=${data?.year || ''}`;
    return protectedInstance.get(`/company/${companyId}/lots?${query}`)
        .then((res: AxiosResponse<PaginationResponse<LotList[]>>) => res.data)
}

async function getLotItems(companyId: number, lotId: number) {
    return protectedInstance.get(`/company/${companyId}/lot/${lotId}/planItems`)
        .then((res: AxiosResponse<Response<LotItem[]>>) => res.data)
}

async function deleteLot(companyId: number, lotId: number) {
    return protectedInstance.delete(`/company/${companyId}/lot/${lotId}`)
        .then((res: AxiosResponse<Response<any>>) => res.data)
}

async function deleteLotFile(companyId: number, lotFileId: number, lotId: number) {
    return protectedInstance.delete(`/company/${companyId}/lot/${lotId}/file/${lotFileId}`)
        .then((res: AxiosResponse<Response<any>>) => res.data)
}

async function getLotFiles(companyId: number, lotId: number) {
    return protectedInstance.get(`/company/${companyId}/lot/${lotId}/files`)
        .then((res: AxiosResponse<Response<LotCompanyFile[]>>) => res.data)
}

async function addLotItems(companyId: number, lotId: number, items: number[]) {
    return protectedInstance.post(`/company/${companyId}/lot/${lotId}/planItems`, items)
        .then((res: AxiosResponse<Response<LotItem[]>>) => res.data)
}

async function addLotFiles(companyId: number, lotId: number, attachments: number[]) {
    return protectedInstance.post(`/company/${companyId}/lot/${lotId}/files`, attachments)
        .then((res: AxiosResponse<Response<LotCompanyFile>>) => res.data)
}

async function getLotsWithItem(companyId: number, page: number, pageSize: number, data: LotsFilterParams | null, lang: string = 'ru') {
    const query = `page=${page}&page_size=${pageSize}&state=${data?.state || ""}&year=${data?.year || ""}&bin=${data?.bin || ""}`;
    return protectedInstance.get(`/company/${companyId}/lotsWithItem?${query}`, {
        headers: {
            "Accept-Language": lang
        }
    }).then((res: AxiosResponse<PaginationResponse<LotWithItemList[]>>) => res.data)
}

async function approveLot(companyId: number, lotId: number) {
    return protectedInstance.put(`/company/${companyId}/lot/${lotId}/approve`)
        .then((res: AxiosResponse<Response<any>>) => res.data)
}

export const lotService = {
    deleteLotItem,
    getLot,
    editLot,
    createLot,
    getLots,
    getLotFiles,
    deleteLot,
    getLotItems,
    deleteLotFile,
    addLotItems,
    addLotFiles,
    getLotsWithItem,
    approveLot
}